import { Box, Stack } from '@mui/material'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import CopyrightTextWrapper from 'wrappers/CopyrightTextWrapper'
import PoweredByWrapper from 'wrappers/poweredBy/PoweredByWrapper'
import { buildFooterSiteLinks } from '../../../util/siteLink.helpers'
import OutsideLink from '../../links/OutsideLink'

const Footer = () => {
  // multiLanguage: { languageLink, selectedLanguage, renderLanguagePopup }
  const { t } = useTranslation()
  return (
    <Stack spacing={1} alignItems='center' sx={{ pb: 2 }}>
      <Box
        sx={{
          gap: 3,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row'
        }}
      >
        {buildFooterSiteLinks(t).map(({ label, to }) => (
          <OutsideLink
            key={label}
            href={to}
            color='inherit'
            variant='body2'
            label={label}
          />
        ))}
      </Box>
      <CopyrightTextWrapper />
      <PoweredByWrapper />
    </Stack>
  )
}

export default memo(Footer)
